import { GTValidator } from './GtValidator'

export class GTZeroValidator extends GTValidator {
    constructor() {
        super(0)
    }
}
